import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
import { TimecardApi } from 'shared/sdk';

@Component({
    selector: 'app-timesheet-num-lookup',
    templateUrl: './timesheet-num-lookup.component.html',
    styleUrls: ['./timesheet-num-lookup.component.css']
})
export class TimesheetNumLookupComponent implements OnInit {
    @Input() set resetData(isClear) {
        this.timesheetNumbersObj = [];
    }
    @Input() isMultiSelect = true;
    @Output() getTimesheetNumbersObj: EventEmitter<any> = new EventEmitter();

    timesheetNumbers: any[] = [];
    public searchInput = new EventEmitter<string>();
    itemsPerBatch = 50;
    notFoundText: string;
    timesheetNumbersObj: any[] = [];

    constructor(private _timecardApi: TimecardApi) { }

    ngOnInit() {
        const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
        this.timesheetNumbersObj = (preselected && preselected['timesheetNumbers']) ?
            preselected['timesheetNumbers'] : [];
        if (this.timesheetNumbersObj && this.timesheetNumbersObj.length) {
            this._timecardApi.find({
                where: { sfdcId: { inq: this.timesheetNumbersObj } },
                fields: ['sfdcId', 'Name'],
                limit: this.itemsPerBatch
            }).subscribe(
                (x: any[]) => { this.timesheetNumbers = x; },
                () => { this.timesheetNumbers = []; }
            );
        }
        this.getTimesheetNumbers();
    }

    getTimesheetNumbers() {
        this.searchInput.pipe(
            filter(search => search && search.length > 2),
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(search => this._timecardApi.find({
                where: { Name: { ilike: '%' + search.trim() + '%', options: 'i' } },
                fields: ['sfdcId', 'Name'],
                limit: this.itemsPerBatch,
                order: 'Name ASC'
            }))
        ).subscribe(
            (x: any[]) => {
                this.timesheetNumbers = x;
                this.notFoundText = x.length === 0 ? 'No timesheet number found.' : '';
            },
            () => { this.timesheetNumbers = []; }
        );
    }

    clearTimesheetNumbers() {
        this.timesheetNumbersObj = [];
        this.notFoundText = 'Type to search timesheet number';
        this.getTimesheetNumbersObj.emit([]);
    }

    onTimesheetNumberChange() {
        this.getTimesheetNumbersObj.emit(this.timesheetNumbersObj);
    }
}
